/**
 * OpenUI fence language helpers (server-safe).
 */

export const OPENUI_FENCE_LANGUAGES = new Set([
  'openui',
  'openui-lang',
  'oui',
  'open-ui'
])

export function isOpenUIFenceLanguage(language: string | undefined | null) {
  if (!language) return false
  return OPENUI_FENCE_LANGUAGES.has(language.trim().toLowerCase())
}
